import React, { Suspense, lazy } from 'react'
import { TextField, Button, Grid, IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { v4 as uuidv4 } from 'uuid'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Creatable from 'react-select/creatable';
// import isMobilePhone from 'validator/es/lib/isMobilePhone';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const LocationMap = lazy(() => import('../Map/LocationMap'))

const DisplayingErrorMessagesSchema = Yup.object().shape({
    id: Yup.string().default(() => uuidv4()).required(),
    address: Yup.string().required('Required'),
    doorNumber: Yup.string().required('Required'),
    landmark: Yup.string().optional().nullable(),
    coordinates: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required()
    }),
    phoneNumber: Yup.string().optional().min(10, '10 digit number').max(10, '10 digit number'),
    label: Yup.string().default(() => '').required('Required').nullable()
});


const useStyles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'no-wrap'
    }

}));


const AddNewAddress = (props) => {
    const classes = useStyles()
    const { onClose, isOpen } = props
    const formRef = React.useRef()

    function onButtomClick() {
        if (formRef.current) {
            formRef.current.handleSubmit()
        }
    }

    const theme = useTheme();
    const xs = useMediaQuery(theme.breakpoints.down('xs'))
    const dialogProps = {
        fullWidth: true
    }
    if (xs) {
        dialogProps.fullScreen = true
    } else {
        dialogProps.fullScreen = false
    }

    return (

        <Dialog
            {...dialogProps}
            open={isOpen}
            onClose={onClose}
            aria-labelledby="Add New Address"
            aria-describedby="Add New Address"
        >
            <DialogTitle>
                <div className={classes.row}>
                    <Typography component="p" variant="body1" align="left" color="primary">
                        <strong>Add Delivery Address</strong>
                    </Typography>
                    <IconButton onClick={onClose} color="primary">
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                <Formik
                    innerRef={formRef}
                    enableReinitialize
                    initialValues={{
                        id: uuidv4(),
                        address: '',
                        coordinates: {
                            lat: '',
                            lng: ''
                        },
                        doorNumber: '',
                        landmark: '',
                        phoneNumber: '',
                        label: ''
                    }}
                    validationSchema={DisplayingErrorMessagesSchema}
                    onSubmit={values => {
                        // console.log(values);
                        props.handleSubmit(values)
                    }}
                >
                    {({ errors, touched, setStatus }) => (
                        <Form>

                            <Field name="address" type="text" >
                                {({
                                    field, // { name, value, onChange, onBlur }
                                    form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                    meta,
                                }) => (
                                        <div onBlur={() => form.setFieldTouched('address', true)}>
                                            <Suspense fallback={<div>Loading...</div>}>
                                                <LocationMap
                                                    updateLocation={({ lat, lng, description }) => {
                                                        form.setFieldValue('address', description)
                                                        form.setFieldValue('coordinates.lat', lat)
                                                        form.setFieldValue('coordinates.lng', lng)
                                                    }} />
                                            </Suspense>
                                            {
                                                field.value &&
                                                <Typography component="p" variant="body1" align="left" color="primary" style={{ marginTop: "1rem" }}>
                                                    {field.value}
                                                </Typography>
                                            }
                                            {meta.touched && meta.error && <Typography color="error" component="div" variant="subtitle1">{meta.error}</Typography>}
                                        </div>
                                    )}
                            </Field>


                            <Grid container>
                                <Grid item xs={12} sm={6} style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                                    <Field name="doorNumber" type="text">
                                        {({
                                            field, // { name, value, onChange, onBlur }
                                            form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                            meta,
                                        }) => (
                                                <div>
                                                    <TextField {...field} label="House No./Plot No. *" fullWidth variant="outlined" size="small" />
                                                    {meta.touched && meta.error && <Typography color="error" component="div" variant="subtitle1">{meta.error}</Typography>}
                                                </div>
                                            )}
                                    </Field>

                                </Grid>

                                <Grid item xs={12} sm={6} style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                                    <Field name="label" >
                                        {({
                                            field, // { name, value, onChange, onBlur }
                                            form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                            meta,
                                        }) => (
                                                <div>
                                                    <Creatable required isClearable
                                                        placeholder="Label eg. friend's place *" aria-label="Address Label"
                                                        options={[{ label: "Home", value: "Home" }, { label: "Work", value: "Work" }]}
                                                        onChange={(newValue) => form.setFieldValue('label', newValue.value)}
                                                        onBlur={() => form.setFieldTouched('label', true)}
                                                    />
                                                    {meta.touched && meta.error && <Typography color="error" component="div" variant="subtitle1">{meta.error}</Typography>}
                                                </div>
                                            )}
                                    </Field>
                                </Grid>

                                <Grid item xs={12} sm={6} style={{ marginBottom: "1rem", marginTop: "1rem" }}>

                                    <Field name="landmark" type="text">
                                        {({
                                            field, // { name, value, onChange, onBlur }
                                            form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                            meta,
                                        }) => (
                                                <div>
                                                    <TextField {...field} label="Landmark (optional)" fullWidth variant="outlined" size="small" />
                                                    {meta.touched && meta.error && <Typography color="error" component="div" variant="subtitle1">{meta.error}</Typography>}
                                                </div>
                                            )}
                                    </Field>

                                </Grid>

                                <Grid item xs={12} sm={6} style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                                    <Field name="phoneNumber" type="text">
                                        {({
                                            field, // { name, value, onChange, onBlur }
                                            form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                            meta,
                                        }) => (
                                                <div>
                                                    <TextField {...field} label="Phone number (optional)" placeholder="10 digit number" fullWidth variant="outlined" size="small" />
                                                    {meta.touched && meta.error && <Typography color="error" component="div" variant="subtitle1">{meta.error}</Typography>}
                                                </div>
                                            )}
                                    </Field>
                                </Grid>

                            </Grid>



                            {/* <Button type="submit" size="large" variant="contained" color="secondary">Add and Continue</Button> */}
                        </Form>
                    )}
                </Formik>
            </DialogContent>
            <DialogActions>
                <Button type="submit" size="small" variant="contained" color="secondary" onClick={onButtomClick}>Add and Continue</Button>
            </DialogActions>
        </Dialog>
    )




}



export default AddNewAddress